module.exports = __webpack_public_path__ + "img/banner1.9175da69.png";